import MuiButton from '@material-ui/core/Button';
import MuiIconButton from '@material-ui/core/IconButton';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import React from 'react';
import { Icon } from '../';
import { BLACK_GREY, HIGHLIGHT, TEXT } from '../Colors';

const StyledButton = withStyles({
    root: {
        display: 'inline-block',
        borderRadius: '4px',
        color: TEXT,
        padding: '4px',
        minHeight: '32px',
        minWidth: '32px',
        height: '32px',
        width: '32px',
        '&.MuiButton-contained.Mui-disabled': {
            opacity: 0.5,
            color: TEXT,
            backgroundColor: BLACK_GREY,
        },
        '&.MuiButton-root.Mui-disabled': {
            opacity: 0.5,
            color: TEXT
        },
        '&>.MuiButton-label': {
            height: '100%',
            width: '100%'
        }
    },
    contained: {
        backgroundColor: BLACK_GREY,
        "&:hover, &:focus": {
            backgroundColor: HIGHLIGHT
        }
    }
})(MuiButton);

const StyledIconButton = withStyles({
    root: {
        display: 'inline-block',
        borderRadius: '4px',
        color: TEXT,
        padding: '4px',
        minHeight: '32px',
        minWidth: '32px',
        height: '32px',
        width: '32px',
        '&.Mui-disabled': {
            opacity: 0.5,
            color: TEXT
        },
        '&:hover': {
            color: HIGHLIGHT
        },
        '&:focus, &:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.04)'
        },
        '&>.MuiIconButton-label': {
            height: '100%',
            width: '100%'
        }
    }
})(MuiIconButton);

const useStyles = makeStyles({
    fullWidth: {
        width: '100%',
        minWidth: '0px'
    },
    fullHeight: {
        height: '100%',
        minHeight: '0px'
    },
    hidden: {
        display: 'none',
    },
});

interface IconButtonProps {
    children: React.ReactElement, // Only allow single child, no text
    type: 'primary' | 'secondary'
    hidden?: boolean,
    disabled?: boolean,
    autoFocus?: boolean,
    fullWidth?: boolean,
    fullHeight?: boolean,
    onClick?(event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void,
    ref?: React.Ref<HTMLButtonElement>,
}

export const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>((props, ref) => {
    const classes = useStyles();

    // "stylingClassName" is used for "styled components" extensions. It is hidden from the developer.
    const stylingClassName = (props as any).className ? (props as any).className : '';

    const onClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        if (props.onClick) {
            props.onClick(event);
        }
    }

    const className = `${props.fullWidth ? classes.fullWidth : ''} ${props.fullHeight ? classes.fullHeight : ''} ${props.hidden ? classes.hidden : ''} ${stylingClassName}`;

    if (props.type === "primary") {
        return (
            <StyledButton
                ref={ref}
                hidden={props.hidden}
                className={className}
                variant="contained"
                disabled={props.disabled}
                autoFocus={props.autoFocus}
                onClick={event => onClick(event)}>
                {<Icon>{props.children}</Icon>}
            </StyledButton>);
    } else {
        return (
            <StyledIconButton
                ref={ref}
                hidden={props.hidden}
                className={className}
                disabled={props.disabled}
                autoFocus={props.autoFocus}
                onClick={event => onClick(event)}>
                {<Icon>{props.children}</Icon>}
            </StyledIconButton>);
    }
});
